import { ACCOUNTS_SERVICE_URI } from "env";
import { assertOk, proxyFetch, assertResponseBodySuccess } from "../utils";

export { default as useGetAccountInfo } from "./useGetAccountInfo";
export { default as useUpdateAccountInfo } from "./useUpdateAccountInfo";

const accountsProxy = proxyFetch(ACCOUNTS_SERVICE_URI);

export const getAccountInfo = async (ctx) => {
  const response = await accountsProxy(ctx, `/v1/user-info`, "GET");
  assertOk(response);
  return response.json();
};

export const sendEmailVerificationCode = async (ctx, email) => {
  if (!email) {
    throw new Error("You must provide a valid email");
  }
  const response = await accountsProxy(ctx, `/v1/user-info/email/begin-verify`, "POST", {
    email,
  });
  assertOk(response);
  return response.json();
};

export const verifyEmailVerificationCode = async (ctx, code, nonce) => {
  if (!code) {
    throw new Error("You must provide a valid email verification code");
  }
  if (!nonce) {
    throw new Error("Unable to finish verification. Nonce is");
  }
  const response = await accountsProxy(ctx, `/v1/user-info/email/finish-verify`, "POST", {
    code,
    nonce,
  });
  const json = await response.json();
  assertResponseBodySuccess(json);
  return json;
};

export const getPrimaryEmail = async (ctx) => {
  const response = await accountsProxy(ctx, "/v1/user-info/email/primary", "GET");
  assertOk(response);
  return response.json();
};

export const updateAccountInfo = async (ctx, formData) => {
  const response = await accountsProxy(ctx, "/user-info/details", "PATCH", formData);
  assertOk(response);
  return response.json();
};
